import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface Dataset {
  datasetName: string;
  datasetId: string;
  datasetDescription: string;
  processingCompletedOn: string;
}

interface WorkspaceDatasetState {
  workspaceDataset: Dataset[];
}

const initialState: WorkspaceDatasetState = {
  workspaceDataset: [],
};

const workspaceSlice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    setWorkspaceData: (state, action: PayloadAction<Dataset[]>) => {
      console.log(action);
      state.workspaceDataset = {...action.payload};
    },
    addWorkspaceData: (state, action: PayloadAction<Dataset>) => {
      state.workspaceDataset.push(action.payload);
    },
    clearWorkspaceData: (state) => {
      state.workspaceDataset = [];
    },
  },
});

export const {setWorkspaceData, addWorkspaceData, clearWorkspaceData} =
  workspaceSlice.actions;

export default workspaceSlice.reducer;
